module.exports = __webpack_public_path__ + "img/classic_shop_thumbnail-400x300.c3d3d8f6.jpg";